// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 3.6V12.4',
  'M7.75 3.85L12.28 6.23C14.14 7.21 14.14 8.79 12.28 9.77L7.75 12.15C6.53 12.78 5.55 12.19 5.55 10.82L5.55 5.18C5.55 3.81 6.53 3.22 7.75 3.85Z',
];
